import {Injectable} from '@angular/core';
import {EntityState, SignalEntityStore} from 'src/app/modules/shared/state/signal-entity.store';
import {ClaimDetails} from 'src/app/modules/shared/models/claim.model';

export interface ClaimState extends EntityState<ClaimDetails> {
}

export function createInitialState(): ClaimState {
  return {
    claim_id: 0,
    policy_id: '',
    session_id: '',
    claim_name: '',
    state: 'InProgress',
    last_question_id: 0,
    current_question_id: 0,
    claim_type_id: 0,
    selected_classes: '',
    current_collation_id: '',
    emergency_code: 0
  };
}

@Injectable({
  providedIn: 'root'
})
export class ClaimStore extends SignalEntityStore<ClaimDetails, ClaimState> {
  constructor() {
    super({name: 'claim', initialState: createInitialState()});
  }
}
